import Header from 'components/VerticalLayout/Header';
import React, { useState } from 'react';
import bgImage from "../../../../assets/images/bgImage1.jpg";
import {
    Button,
    Card,
    Col,
    Container,
    Form,
    FormGroup,
    Modal,
    ModalBody,
    ModalHeader,
    Row
} from 'reactstrap';
import AddCreditButton from 'pages/Dboard/Profile/AddCreditButton';
import { useForm } from 'react-hook-form';
import { FaArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import StaxCheckoutPage from './StaxCheckoutPage';

const PaymentsPageStax = () => {

    const navigate = useNavigate();

    const handleHistory = () => {
        navigate('/payment-history');
    };


    // =========================
    // Stax Payment Modal
    // =========================

    const [isStaxModalOpen, setIsStaxModalOpen] = useState(false);


    // =========================
    // Confirmed Payment Amount
    // =========================
    // This should NOT be synchronized with react-hook-form.
    // It represents the amount currently being paid in Stax.

    const [amt, setAmt] = useState(0);


    // =========================
    // React Hook Form
    // =========================

    const {
        register,
        formState: { errors },
        setValue,
        handleSubmit,
        reset
    } = useForm({
        defaultValues: {
            customAmount: "",
        },
        criteriaMode: "all",
        mode: "onChange"
    });


    // =========================
    // Submit
    // =========================

    const onSubmit = (data) => {

        const selectedAmount = Number(data.customAmount);

        if (!selectedAmount || selectedAmount < 1) {
            return;
        }

        console.log(
            "Selected Stax amount:",
            selectedAmount
        );


        /*
         * Store the confirmed payment amount.
         *
         * This is separate from react-hook-form.
         */
        setAmt(selectedAmount);


        /*
         * Open Stax checkout modal.
         */
        setIsStaxModalOpen(true);


        /*
         * IMPORTANT:
         *
         * Do NOT call reset() here.
         *
         * reset() would change customAmount to ""
         * while the Stax modal is using the amount.
         */
    };


    // =========================
    // Close Stax Modal
    // =========================

    const closeStaxModal = () => {

        setIsStaxModalOpen(false);

        /*
         * Clear the confirmed payment amount
         * only after the Stax modal is closed.
         */
        setAmt(0);

        /*
         * Now it is safe to reset the form.
         */
        reset();
    };


    return (
        <div className='account'>

            <Header />

            <div
                className='accountbg'
                style={{
                    background: `url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundAttachment: "fixed",
                    paddingTop: "80px",
                    minHeight: "100vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    paddingLeft: "8px"
                }}
            >

                <div className='d-flex justify-content-center'>

                    <Card
                        className="p-4"
                        style={{
                            width: "600px",
                            maxWidth: "100%",
                            minHeight: "80vh"
                        }}
                    >

                        {/* =========================
                            PAGE HEADER
                        ========================== */}

                        <div className="border-bottom pb-2 mb-4 d-flex justify-content-between">

                            <div>

                                <h5 className="fw-bold">
                                    Add Credits
                                </h5>

                                <p
                                    className='text-muted mb-0'
                                    style={{ fontSize: '0.7rem' }}
                                >
                                    Purchase credits via secure payment gateway
                                </p>

                            </div>


                            <div>

                                <button
                                    className='btn py-2'
                                    style={{
                                        backgroundColor: "#00ADF0",
                                        color: "white",
                                        minWidth: "150px",
                                        fontWeight: "bolder"
                                    }}
                                    onClick={handleHistory}
                                >
                                    Payment History
                                </button>

                            </div>

                        </div>


                        <Container fluid>

                            {/* =========================
                                $100 / $250
                            ========================== */}

                            <Row className='mb-4'>

                                <Col>

                                    <AddCreditButton
                                        text="$100"
                                        onClick={() =>
                                            setValue(
                                                "customAmount",
                                                100,
                                                {
                                                    shouldValidate: true,
                                                    shouldDirty: true
                                                }
                                            )
                                        }
                                    />

                                </Col>


                                <Col>

                                    <AddCreditButton
                                        text="$250"
                                        onClick={() =>
                                            setValue(
                                                "customAmount",
                                                250,
                                                {
                                                    shouldValidate: true,
                                                    shouldDirty: true
                                                }
                                            )
                                        }
                                    />

                                </Col>

                            </Row>


                            {/* =========================
                                $500 / $1000
                            ========================== */}

                            <Row className='mb-4'>

                                <Col>

                                    <AddCreditButton
                                        text="$500"
                                        onClick={() =>
                                            setValue(
                                                "customAmount",
                                                500,
                                                {
                                                    shouldValidate: true,
                                                    shouldDirty: true
                                                }
                                            )
                                        }
                                    />

                                </Col>


                                <Col>

                                    <AddCreditButton
                                        text="$1000"
                                        onClick={() =>
                                            setValue(
                                                "customAmount",
                                                1000,
                                                {
                                                    shouldValidate: true,
                                                    shouldDirty: true
                                                }
                                            )
                                        }
                                    />

                                </Col>

                            </Row>


                            {/* =========================
                                $2500 / $5000
                            ========================== */}

                            <Row className='mb-4'>

                                <Col>

                                    <AddCreditButton
                                        text="$2500"
                                        onClick={() =>
                                            setValue(
                                                "customAmount",
                                                2500,
                                                {
                                                    shouldValidate: true,
                                                    shouldDirty: true
                                                }
                                            )
                                        }
                                    />

                                </Col>


                                <Col>

                                    <AddCreditButton
                                        text="$5000"
                                        onClick={() =>
                                            setValue(
                                                "customAmount",
                                                5000,
                                                {
                                                    shouldValidate: true,
                                                    shouldDirty: true
                                                }
                                            )
                                        }
                                    />

                                </Col>

                            </Row>


                            {/* =========================
                                CUSTOM AMOUNT
                            ========================== */}

                            <Form onSubmit={handleSubmit(onSubmit)}>

                                <Row>

                                    <Col>

                                        <FormGroup>

                                            <input
                                                type='number'
                                                style={{
                                                    width: '540px'
                                                }}
                                                min={1}
                                                className='form-control border-primary-subtle'
                                                id='customAmount'
                                                placeholder='Enter Custom amount'
                                                {...register(
                                                    "customAmount",
                                                    {
                                                        required:
                                                            "Please enter an amount",

                                                        min: {
                                                            value: 1,
                                                            message:
                                                                "Minimum amount is $1"
                                                        }
                                                    }
                                                )}
                                            />


                                            {errors.customAmount && (

                                                <span className='text-danger'>

                                                    {
                                                        errors
                                                            .customAmount
                                                            .message
                                                    }

                                                </span>

                                            )}

                                        </FormGroup>

                                    </Col>

                                </Row>


                                {/* =========================
                                    PROCEED TO PAY
                                ========================== */}

                                <Row>

                                    <Button
                                        type='submit'
                                        className='btn w-100 py-2'
                                        style={{
                                            backgroundColor: "#00ADF0",
                                            color: "white"
                                        }}
                                    >

                                        Proceed to Pay

                                        {amt
                                            ? ` $${Number(amt).toFixed(2)}`
                                            : ''
                                        }

                                        <FaArrowRight />

                                    </Button>

                                </Row>


                                {/* =========================
                                    SECURITY MESSAGE
                                ========================== */}

                                <Row className='text-center mt-2'>

                                    <p
                                        className='text-muted mb-0'
                                        style={{
                                            fontSize: '0.7rem'
                                        }}
                                    >
                                        🔒 Payments processed securely via
                                        Stax. Credits are added upon
                                        successful payment.
                                    </p>

                                </Row>

                            </Form>


                            {/* =========================
                                STAX PAYMENT MODAL
                            ========================== */}

                            <Modal
                                isOpen={isStaxModalOpen}
                                toggle={closeStaxModal}
                                centered
                                size="lg"
                            >

                                <ModalHeader
                                    toggle={closeStaxModal}
                                >
                                    Complete Payment
                                </ModalHeader>


                                <ModalBody>

                                    <StaxCheckoutPage
                                        amount={amt}

                                        onSuccess={(response) => {

                                            console.log(
                                                "Stax payment successful:",
                                                response
                                            );

                                            closeStaxModal();

                                        }}

                                        onClose={() => {

                                            closeStaxModal();

                                        }}
                                    />

                                </ModalBody>

                            </Modal>

                        </Container>

                    </Card>

                </div>

            </div>

        </div>
    );
};

export default PaymentsPageStax;